// @flow

import {
  getShortestDeliveryTime,
  getSize,
  getMake,
  getFueltype,
  getDiscountPrice,
  getTransmission,
  getBodystyle,
  getProductType,
} from '../../pdb/selectors';

export type FacetConfig = { [string]: Function };

export default {
  make: getMake,
  fueltype: getFueltype,
  price: getDiscountPrice,
  size: getSize,
  transmission: getTransmission,
  bodywork: getBodystyle,
  deliveryTime: getShortestDeliveryTime,
  product_type: getProductType,
};
